import React, { Component } from 'react'
import _ from 'lodash'
import Modal from 'react-modal'
import AuthContainer from '../../containers/auth/AuthContainer'
import MenuContainer from '../../containers/layout/MenuContainer'
import GuestContent from './GuestContent'
import GuestMenu from './GuestMenu'
import { BACKEND_URL_PREFIX, version } from '../../utils/const'
import { PATHS } from '../Routes'
import { Link } from 'react-router-dom'
import s from './Layout.module.scss'

import DashboardContainer from '../../containers/Dashboard/DashboardContainer'

// страница входа: гость и не один из публичных маршрутов
const isLoginPage = (path, token) => !token && !_.includes(PATHS.GUEST, path)

// ширину колонки контента объявляет сам режим — хуком usePageWidth
// (src/components/shared/usePageWidth.js); оболочка о маршрутах ничего не знает

const contentAccess = (path, token, children, links) =>
  isLoginPage(path, token) ? <GuestContent links={links} /> : children

export default class Layout extends Component {
  constructor(props) {
    super(props)
    this.state = { modal: false, isAuthCard: false }
    this.handleModalClose = this.handleModalClose.bind(this)
  }

  componentDidMount() {
    typeof (this.props.ssoAuth) === 'boolean' && this.props.didMount()
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.ssoAuth === null && typeof (nextProps.ssoAuth) === 'boolean') {
      this.props.didMount()
    }
    if (nextProps.error) {
      this.setState({ modal: true })
    }
  }

  handleModalClose() {
    const { closeModal } = this.props
    this.setState({ modal: false })
    closeModal()
  }

  render() {
    const {
      token,
      history,
      children,
      data: { GOU_Name, address, phones },
      error,
      links,
    } = this.props

    const loginPage = isLoginPage(history.location.pathname, token)

    return (
      <>
        {
          (history.location.pathname.includes('dashboard'))
            ?
            <DashboardContainer></DashboardContainer>
            :

            <div
              className={`page-content${loginPage ? ' page-content--guest' : ''}`}
              id='page-content'
            >
              <div className='header'>
                <div className='content header__content'>
                  {token ? (
                    <Link to={'/lk'}>
                      <img className='header__logo' src={`${BACKEND_URL_PREFIX}/company/gou_logo`} alt='Логотип' />
                    </Link>
                  ) : (
                    <img className='header__logo' src={`${BACKEND_URL_PREFIX}/company/gou_logo`} alt='Логотип' />
                  )}

                  <div className='header__right'>
                    <p className='header__subtitle'>{GOU_Name}</p>
                    <h1 className='header__title'>СИСТЕМА ПЛАНИРОВАНИЯ И УПРАВЛЕНИЯ УЧЕБНЫМ ПРОЦЕССОМ</h1>
                    <AuthContainer
                      history={history}
                      isAuthCard={this.state.isAuthCard}
                      setIsAuthCard={isAuthCard => this.setState({ isAuthCard })}
                    />
                    {loginPage ? null : <MenuContainer />}
                  </div>
                </div>
              </div>

              {loginPage ? <GuestMenu /> : null}

              {/* {window.location.search && <div className={'all_screen_plug'}></div>} */}

              <div className='main-content'>
                {contentAccess(history.location.pathname, token, children, links)}
              </div>

              <div className='footer'>
                <div className='content footer__content'>
                  <p className='column'>
                    © 2017-{new Date().getFullYear()} {GOU_Name}
                    <span>
                      {address} {phones}
                    </span>
                  </p>
                  <p style={{ marginBottom: '0px' }}>© 2017-{new Date().getFullYear()} OOO “Нинтегра”</p>
                </div>
                <div className='version'>{version}</div>
              </div>
              <Modal
                isOpen={this.state.modal}
                onRequestClose={this.handleModalClose}
                ariaHideApp={false}
                className={s.errorModal}
                overlayClassName={s.errorOverlay}
              >
                <div className={s.errorText}>{error}</div>
                <button autoFocus className={s.errorButton} onClick={this.handleModalClose}>
                  ОК
                </button>
              </Modal>
            </div>

        }
      </>
    )
  }
}
